import { Button } from '@material-ui/core';
import React, {useContext, useState} from 'react';
import { AuthContext } from './context';
import {db, storage} from "./FirebaseConfig";
import firebase from 'firebase';
import './styles/PostUpload.css';

const ImageUpload = () => {

    const [image, setImage] = useState(null);
    const [progress, setProgress] = useState(0);
    const [caption, setCaption] = useState('');
    const { user } = useContext(AuthContext);

    const handleChange = e => {
        if (e.target.files[0]){
            setImage(e.target.files[0]);
        }
    }

    const handleUpload = () => {
        const uploadTask = storage.ref(`images/${image.name}`).put(image);
        uploadTask.on(
            'state_changed',
            (snapshot) => {
                //progress
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) *100
                );
                setProgress(progress);
            },
            (error) => {
                console.log(error);
                alert(error.message);
            },
            () => {
                //complete fn
                storage.ref('images').child(image.name).getDownloadURL()
                .then(url => {
                    //post img in db
                    db.collection('posts').add({
                        timestamp : firebase.firestore.FieldValue.serverTimestamp(),
                        caption : caption,
                        image : url,
                        username : user.displayName
                    });
                });
                setProgress(0);
                setCaption('');
                setImage(null);
            }
        );
    }

    return(
        <div>
            {user ? (
                <div className = 'imageupload'>
                    <h3>Create a post:</h3>
                    <progress className = 'imageupload_progress' value = {progress} max = '100' />
                    <input className = 'imageupload_input' type = 'text' placeholder = 'Enter a caption...' onChange = {e => setCaption(e.target.value)} />
                    Select Picture :<input className = 'imageupload_input' type = 'file' onChange = {handleChange}/>
                    <Button className = 'imageupload_input' disabled = {!image} onClick = {handleUpload}>Upload</Button>   
                </div>
            ):''
            }
            
        </div>
        
    );
}

export default ImageUpload;